
export default interface FiltersToggleState {
  showFilters: boolean;
};

export const initialFiltersToggleState: FiltersToggleState = {
  showFilters: true
};
